const consumption = {
  path: 'consumption',
  component: resolve => require(['@/pages/admin/trading/consumption'], resolve)
}

export default consumption
